export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "open-user-menu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ouvrir le menu utilisateur"])}
      },
      "en": {
        "open-user-menu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open user menu"])}
      }
    }
  })
}
